var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame572(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0820312 10.7422C0.0820312 5.21934 4.55918 0.742188 10.082 0.742188H32.8906C38.4135 0.742188 42.8906 5.21934 42.8906 10.7422V33.5508C42.8906 39.0736 38.4135 43.5508 32.8906 43.5508H10.082C4.55918 43.5508 0.0820312 39.0736 0.0820312 33.5508V10.7422Z",
    fill: "#123051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4863 26.1484L26.4863 26.1484C28.6955 26.1484 30.4863 24.3576 30.4863 22.1484C30.4863 19.9393 28.6955 18.1484 26.4863 18.1484L24.4863 18.1484M17.4863 22.1484L25.4863 22.1484M18.4863 18.1484L16.4863 18.1484C14.2772 18.1484 12.4863 19.9393 12.4863 22.1484C12.4863 24.3576 14.2772 26.1484 16.4863 26.1484L18.4863 26.1484",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame572);
export default __webpack_public_path__ + "static/media/Frame 572.0adee29d1b46d4f0f6146037a28f7fe2.svg";
export { ForwardRef as ReactComponent };